import React from "react";

interface UserIconProps {
  className?: string;
}

export const UserIcon = ({ className }: UserIconProps) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3333 11C20.3333 12.4145 19.7714 13.771 18.7712 14.7712C17.771 15.7714 16.4145 16.3333 15 16.3333C13.5855 16.3333 12.229 15.7714 11.2288 14.7712C10.2286 13.771 9.66666 12.4145 9.66666 11C9.66666 9.58552 10.2286 8.22896 11.2288 7.22877C12.229 6.22857 13.5855 5.66667 15 5.66667C16.4145 5.66667 17.771 6.22857 18.7712 7.22877C19.7714 8.22896 20.3333 9.58552 20.3333 11ZM17.6667 11C17.6667 11.7072 17.3857 12.3855 16.8856 12.8856C16.3855 13.3857 15.7072 13.6667 15 13.6667C14.2928 13.6667 13.6145 13.3857 13.1144 12.8856C12.6143 12.3855 12.3333 11.7072 12.3333 11C12.3333 10.2928 12.6143 9.61448 13.1144 9.11439C13.6145 8.61429 14.2928 8.33334 15 8.33334C15.7072 8.33334 16.3855 8.61429 16.8856 9.11439C17.3857 9.61448 17.6667 10.2928 17.6667 11Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 0.333336C6.9 0.333336 0.333332 6.9 0.333332 15C0.333332 23.1 6.9 29.6667 15 29.6667C23.1 29.6667 29.6667 23.1 29.6667 15C29.6667 6.9 23.1 0.333336 15 0.333336ZM3 15C3 17.7867 3.95067 20.352 5.544 22.3893C6.66297 20.9199 8.10653 19.729 9.76191 18.9098C11.4173 18.0905 13.2397 17.6651 15.0867 17.6667C16.9098 17.6649 18.7092 18.0794 20.3479 18.8784C21.9866 19.6774 23.4213 20.8399 24.5427 22.2773C25.6979 20.7621 26.4758 18.9936 26.8119 17.1181C27.1479 15.2426 27.0326 13.314 26.4753 11.492C25.9181 9.66991 24.935 8.00673 23.6073 6.64005C22.2797 5.27337 20.6457 4.24248 18.8405 3.63268C17.0354 3.02288 15.1109 2.8517 13.2265 3.1333C11.342 3.4149 9.55172 4.14119 8.00369 5.25207C6.45566 6.36296 5.19441 7.8265 4.3243 9.5216C3.4542 11.2167 3.00024 13.0946 3 15ZM15 27C12.2453 27.0041 9.57369 26.0565 7.43733 24.3173C8.29724 23.0863 9.44178 22.0812 10.7736 21.3876C12.1054 20.6939 13.585 20.3323 15.0867 20.3333C16.5695 20.3321 18.0313 20.6848 19.3506 21.3619C20.6698 22.039 21.8085 23.0211 22.672 24.2267C20.5191 26.0223 17.8034 27.0039 15 27Z"
      fill="black"
    />
  </svg>
);

UserIcon.defaultProps = {
  className: "",
};
